import React, { useState, useEffect , useRef} from 'react';  
import ContentLoader from 'react-content-loader'; // Optional, but recommended
import { useNavigate, useLocation, useParams  } from 'react-router-dom';
import { useLanguage } from './language/LanguageContext';
import LanguageSelector from './language/LanguageSelector';
import { faArrowLeft, faCheck, faTimes, faMapMarkerAlt,faTruck, faSearch , faExclamationCircle, faLightbulb, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListView from './images/listView.png';
import GST from './images/gst.png';
import Default from './images/default_img.png';
import BoxHourGlass from './images/orderDetails_icons/box_hourglass.png';
import BoxCheck from './images/orderDetails_icons/box_check.png';
import BoxArrow from './images/orderDetails_icons/box_rightarrow.png';
import CounterOffer from './images/orderDetails_icons/counter_offer.png';
import Boxx from './images/orderDetails_icons/box_x.png';
import Medal from './images/orderDetails_icons/first_medal.png';
import Scooter from './images/orderDetails_icons/scooter_bag.png';
import Shipped from './images/orderDetails_icons/shipped.png';
import BoxReturn from './images/orderDetails_icons/box_return.png';
import Phone from './images/orderDetails_icons/phone.png';
import Whatsapp from './images/orderDetails_icons/whatsapp.png';
import Snackbar from './components/Snackbar';
import { useNotification } from '../context/NotificationContext';
import ArrowLeft from './images/ArrowLeft.png';



const ItemNotAvailableBottomSheet = ({ item, isOpen, onClose, onSuggestAlternative, onMarkNotAvailable }) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />
      
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-12 h-1 bg-gray-300 rounded-full"></div>
        </div>

        <div className="px-6 pb-8">
          {/* Header */}
          <div className="pb-4">
            <div className="flex justify-between items-start mb-2">
              <h3 className="text-lg font-semibold text-gray-900 truncate pr-2">{item.item_name}</h3>
              <span className="bg-gray-100 text-gray-700 rounded-full px-3 py-1 text-sm font-medium whitespace-nowrap">
                Qty: {item.quantity}
              </span>
            </div>
            <div className="border-t border-gray-200 mt-4"></div>
          </div>

          {/* Suggest Alternative Product */}
          <div 
            onClick={onSuggestAlternative}
            className="flex gap-4 bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4 cursor-pointer hover:bg-blue-100 transition-colors"
          >
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon={faLightbulb} className="text-lg text-blue-600" />
              </div>
            </div>
            <div className="flex-1 space-y-2">
              <div>
                <h4 className="text-sm font-semibold text-blue-900 mb-1">Do you want to provide alternative ?</h4>
                <p className="text-xs text-blue-700 leading-relaxed">
                  Recommend a similar product to customer.
                </p>
              </div>
            </div>
          </div>

          {/* Not Available Option */}
            <div 
            onClick={onMarkNotAvailable}
            className="flex gap-4 bg-red-50 border border-red-200 rounded-lg p-4 mb-6 cursor-pointer hover:bg-red-100 transition-colors"
          >
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon={faExclamationCircle} className="text-lg text-red-600" />
              </div>
            </div>
            <div className="flex-1 space-y-2">
              <div>
                <h4 className="text-sm font-semibold text-red-900 mb-1">Not Available</h4>
                <p className="text-xs text-red-700 leading-relaxed">
                  Mark this item as not available
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


// Suggest Alternative Bottom Sheet
const SuggestAlternativeBottomSheet = ({ item, isOpen, onClose, onBack, preloadedItems, order , setOrder }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filter items based on search query
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredItems(preloadedItems || []);
    } else {
      const filtered = (preloadedItems || []).filter(product =>
        product.item_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        product.sku?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredItems(filtered);
    }
  }, [searchQuery, preloadedItems]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
// Suggest Alternative Bottom Sheet
// Update the handleSuggestProduct function in SuggestAlternativeBottomSheet component
/* const handleSuggestProduct = (suggestedProduct) => {
  // Handle the suggestion logic here
  //console.log('Suggesting product:', suggestedProduct, 'as alternative for:', item);
  
  // Add the suggested item data to the original item
  if (item) {
    // Update the order data to add suggested alternative
    const updatedItems = order.items.map(orderItem => {
      if (orderItem.item_id === item.item_id) {
        return {
          ...orderItem,
          item_name : suggestedProduct.item_name,
          proposed_item_id: suggestedProduct.item_id || suggestedProduct.id,
          selling_price : suggestedProduct.selling_price,
          //proposed_price: suggestedProduct.selling_price, 
          item_image : suggestedProduct.item_image || "",
          not_available: false
        };
      }
      return orderItem;
    });

    // Update the order data state
    setOrder(prevOrderData => ({
      ...prevOrderData,
      items: updatedItems
    }));

    console.log('Updated order with suggested alternative:', {
      originalItem: item.item_name,
      suggestedItem: suggestedProduct.item_name,
      suggestedPrice: suggestedProduct.selling_price,
      updatedOrder: {
        ...order,
        items: updatedItems
      }
    });

    // Close the bottom sheet after suggesting
    onClose();
    
    // Optional: Show success message
    // alert(`"${suggestedProduct.item_name}" suggested as alternative for "${selectedItem.item_name}"`);
  }
}; */

const handleSuggestProduct = (suggestedProduct) => {
  if (item) {
    // Update the order data to add suggested alternative
    const updatedItems = order.items.map(orderItem => {
      if (orderItem.item_id === item.item_id) {
        // Calculate new values for the item
        const newSellingPrice = suggestedProduct.selling_price;
        const newSubtotal = newSellingPrice * orderItem.quantity;
        const newTaxAmount = (newSubtotal * orderItem.tax_rate) / 100;
        const newTotal = Math.round(newSubtotal + newTaxAmount); // Round to nearest integer

        return {
          ...orderItem,
          item_name: suggestedProduct.item_name,
          proposed_item_id: suggestedProduct.item_id,
          selling_price: newSellingPrice,
          subtotal: Math.round(newSubtotal),
          calculated_tax_amount: Math.round(newTaxAmount),
          total: newTotal,
          item_image: suggestedProduct.item_image || "",
          not_available: false
        };
      }
      return orderItem;
    });

    // Calculate new order-level totals
    const newOrderSubtotal = updatedItems.reduce((sum, item) => sum + item.subtotal, 0);
    const newOrderTaxAmount = updatedItems.reduce((sum, item) => sum + item.calculated_tax_amount, 0);
    const newOrderTotal = Math.round(newOrderSubtotal + newOrderTaxAmount); // Round to nearest integer

    // Update the order data state with all calculated values
    setOrder(prevOrderData => ({
      ...prevOrderData,
      items: updatedItems,
      subtotal: Math.round(newOrderSubtotal),
      tax_amount: Math.round(newOrderTaxAmount),
      total: newOrderTotal
    }));

    console.log('Updated order with suggested alternative:', {
      originalItem: item.item_name,
      suggestedItem: suggestedProduct.item_name,
      suggestedPrice: suggestedProduct.selling_price,
      updatedOrder: {
        ...order,
        items: updatedItems,
        subtotal: Math.round(newOrderSubtotal),
        tax_amount: Math.round(newOrderTaxAmount),
        total: newOrderTotal
      }
    });

    // Close the bottom sheet after suggesting
    onClose();
  }
};

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />
      
<div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 max-h-[85vh] overflow-y-auto">
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-12 h-1 bg-gray-300 rounded-full"></div>
        </div>

        <div className="px-6 pb-8">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <FontAwesomeIcon icon={faLightbulb} className="text-2xl text-blue-600 mr-3" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Alternative Products</h3>
                <p className="text-sm text-gray-500">For: {item.item_name}</p>
              </div>
            </div>
            <button 
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <FontAwesomeIcon icon={faTimes} className="text-xl text-gray-500" />
            </button>
          </div>

          {/* Search Bar */}
 {/*          <div className="mb-6">
            <div className="relative">
              <FontAwesomeIcon 
                icon={faSearch} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              />
              <input
                type="text"
                placeholder="Search for alternative products..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div> */}

          {/* Suggested Products List */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-gray-700 mb-3">
             Available Alternatives {filteredItems.length > 0 && `(${filteredItems.length})`}
            </h4>
            
            {loading ? (
              <div className="text-center py-4">
                <p className="text-gray-500">Loading products...</p>
              </div>
            ) : filteredItems.length === 0 ? (
              <div className="text-center py-4 border border-gray-200 rounded-lg">
                <p className="text-gray-500">
                  {searchQuery ? 'No products found matching your search.' : 'No products available.'}
                </p>
              </div>
            ) : (
               <div className="space-y-3 max-h-[60vh] overflow-y-auto">
                {filteredItems.map((product) => (
                  <div 
                    key={product.id || product.item_id} 
                    onClick={() => handleSuggestProduct(product)}
                    className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer"
                  >
                    <div className="w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center">
                     {product.item_image ? (
                      <img 
                        src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${product.item_image}`}
                         alt={product.item_name}
                         className="w-full h-full object-cover rounded-md"
                         />
                       ) : (
                    <FontAwesomeIcon icon={faImage} className="text-gray-400 text-xl" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">{product.item_name}</p>
                      {product.selling_price && (
                         <p className="text-xs font-medium text-green-600">
                          ₹ {Number(product.selling_price).toLocaleString("en-IN")}
                          </p>
                         )}

                    </div>
                    <button 
                      
                      className=" text-gray-500 text-xs font-medium  transition-colors whitespace-nowrap"
                    >
                      Tap to Replace
                    </button>
                    {/* <button 
                      
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors whitespace-nowrap"
                    >
                      Suggest
                    </button> */}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button 
              onClick={onBack}
              className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-3 text-sm font-medium hover:bg-gray-50 transition-colors"
            >
              Back
            </button>
            {/* <button 
              onClick={onClose}
              className="flex-1 bg-blue-600 text-white rounded-lg py-3 text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center"
            >
              <FontAwesomeIcon icon={faLightbulb} className="mr-2" />
              Done
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};


// Create a custom Skeleton Loader
const OrderDetailsSkeleton = (props) => (
  <ContentLoader 
    speed={2}
    width="100%"
    height={600}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {/* Order Header Skeleton */}
    <rect x="0" y="0" rx="10" ry="10" width="100%" height="80" /> 
    
    {/* Status Card Skeleton */}
    <rect x="10" y="100" rx="10" ry="10" width="95%" height="120" />
    
    {/* Items Header */}
    <rect x="10" y="250" rx="4" ry="4" width="200" height="20" />
    
    {/* Multiple Item Skeletons */}
    {[0, 1, 2].map((item, index) => (
      <React.Fragment key={index}>
        <rect 
          x="10" 
          y={300 + index * 100} 
          rx="10" 
          ry="10" 
          width="95%" 
          height="80" 
        />
      </React.Fragment>
    ))}
    
    {/* Bill Details Skeleton */}
    <rect x="10" y="600" rx="10" ry="10" width="95%" height="150" />
  </ContentLoader>
);


const DeliveryValidationModal = ({ visible, onClose }) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-auto">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">
            Delivery Validation Required
          </h3>
          <p className="text-gray-600 text-center mb-6">
            Please select Delivery Included and Delivery Time before submitting.
          </p>
          <div className="flex justify-center">
            <button
              onClick={onClose}
              className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-6 rounded-md transition duration-200"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Animated Loading Spinner Component
const LoadingSpinner = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
    <div className="relative">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="animate-spin w-16 h-16 border-4 border-[#F43042] border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div className="mt-24 text-center">
        <p className="text-[#524D4D] font-medium animate-pulse">
           Loading RFQ Details...
        </p>
      </div>
    </div>
  </div>
);

// Progress Loader Component
const ProgressLoader = ({ progress }) => (
  <div className="fixed top-0 left-0 right-0 z-50">
    <div 
      className="h-1 bg-[#F43042]" 
      style={{ 
        width: `${progress}%`, 
        transition: 'width 0.5s ease-in-out' 
      }}
    ></div>
  </div>
);

function RFQDetails() {
      const location = useLocation();
      const params = useParams();
      // Try getting from state first
const quotationIdFromState = location.state?.quotationId;

// Then try from query string (?quotationId=...)
const searchParams = new URLSearchParams(location.search);
const quotationIdFromQuery = searchParams.get('quotationId');
      //const quotationId = location.state?.quotationId? location.state?.quotationId : params.quotationId;
     const quotationId = quotationIdFromState || quotationIdFromQuery;
      //console.log('Quotation ID:', quotationId);
      const navigate = useNavigate();
      const { language } = useLanguage();
      const [order , setOrder] = useState(null);
         const [snackbarState, setSnackbarState] = useState({
         show: true,
         minimized: false
       });
  const [orderAccepted, setOrderAccepted] = useState(false);
  const [isProposingAmendments, setIsProposingAmendments] = useState(false);
  const [amendedItems, setAmendedItems] = useState([]);
  //console.log('Amended Items:', amendedItems);
const [timeRemaining, setTimeRemaining] = useState(null);
const [isExpired, setIsExpired] = useState(false);
const [isCounterOfferModalOpen, setIsCounterOfferModalOpen] = useState(false);
const [isCounterOfferMode, setIsCounterOfferMode] = useState(false);
const [PriceValidityModalOpen, setPriceValidityModalOpen] = useState(false);
const [priceValidityOption, setPriceValidityOption] = useState(''); 
const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
const [skipOrderReasonsModal, setSkipOrderReasonsModal] = useState(false);
const [selectedSkipReason, setSelectedSkipReason] = useState(null);
const [isCounterOffer, setIsCounterOffer] = useState(false);
const { notifications, setNotifications } = useNotification();
//console.log('Notifications:', notifications);
const [showNavigationWarningModal, setShowNavigationWarningModal] = useState(false);
const [loader, setLoader] = useState(true);
const [loadingProgress, setLoadingProgress] = useState(0);
const [itemsReadyPopup , setItemsReadyPopup] = useState(false);
const [isUpdatingDeliveryStatus, setIsUpdatingDeliveryStatus] = useState(false);
const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
const [otpValues, setOtpValues] = useState(['', '', '', '']);
const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
const [allUOMs, setAllUOMs] = useState([]);
const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
 const [deliveryTime , setDeliveryTime] = useState(null);
const [deliveryIncluded, setDeliveryIncluded] = useState("Yes"); // default Yes
const [showValidationModal, setShowValidationModal] = useState(false);
const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
const [isSuggestAlternativeOpen, setIsSuggestAlternativeOpen] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);
//console.log("selectedItem:", selectedItem);
const [suggestedItems, setSuggestedItems] = useState([]);
const [loadingItems, setLoadingItems] = useState(false);
const [showConfirmationModal, setShowConfirmationModal] = useState(false);


// Add refs for OTP inputs
const otpRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const snackbarRef = useRef(null);

  const minimizeSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: true }));
  };
  
  const expandSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: false }));
  };
  
  const hideSnackbar = () => {
    setSnackbarState({ show: false, minimized: false });
  };

    // Simulate loading progress
  useEffect(() => {
    if (loader) {
      const progressInterval = setInterval(() => {
        setLoadingProgress(prevProgress => {
          if (prevProgress >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 500);

      return () => clearInterval(progressInterval);
    }
  }, [loader]);

 useEffect(() => {
  if (quotationId) {
    fetchQuotationbyId();
  }
  }, [quotationId]);

  useEffect(() => {
  fetchAllUOMs();
}, []);



    
  useEffect(() => {
  if (order && order.waiting_time_expired_at) {

    const expirationTime = new Date(order.waiting_time_expired_at);

    const timer = setInterval(() => {
      const now = new Date();
      const difference = expirationTime - now;

      if (difference <= 0) {
        clearInterval(timer);
        setIsExpired(true);
        setTimeRemaining(null);
        return;
      }

      const minutes = Math.floor(difference / 1000 / 60);  // dynamic minutes
      const seconds = Math.floor((difference / 1000) % 60);

      setTimeRemaining({ minutes, seconds });
    }, 1000);

    return () => clearInterval(timer);
  }
}, [order]);



// Checks notification that are matches with the order id and updates the states in the UI
/*  useEffect(() => {
  // Check if we have notifications and an order
  if (notifications && notifications.length > 0 && order) {
    // Filter notifications that match the current order ID
    const matchingNotifications = notifications.filter(notification => 
      notification.data?.order_id.replace(/"/g, '') === order._id
    );

    // If we have matching notifications, find the most recent one
    if (matchingNotifications.length > 0) {
      const mostRecentNotification = matchingNotifications.reduce((latest, current) => 
        new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest
      );

      // Update order status from the most recent notification
      const newStatus = mostRecentNotification.data.order_status || mostRecentNotification.data.vendor_response_status;

      // Only update if the status is different
      if (newStatus && newStatus !== order.vendor_status) {
        // Create a new order object with updated status
        const updatedOrder = {
          ...order,
          vendor_status: newStatus
        };

        // Update the order state
        setOrder(updatedOrder);

        console.log('Order status updated from notification:', {
          oldStatus: order.vendor_status,
          newStatus: newStatus
        });
      }
    }
  }
}, [notifications, order]);  */

// Checks notification that are matches with the order id and updates the awarded states in the UI
/* useEffect(() => {
  // Check if we have notifications and an order
  if (notifications && notifications.length > 0 && order) {
    // Filter notifications that match the current order ID
    const matchingNotifications = notifications.filter(notification =>
      notification.data?.order_id.replace(/"/g, '') === order._id
    );

    // If we have matching notifications, find the most recent one
    if (matchingNotifications.length > 0) {
      const mostRecentNotification = matchingNotifications.reduce((latest, current) =>
        new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest
      );

      // Extract status from notification
      const newStatus = mostRecentNotification.data.order_status || 
                        mostRecentNotification.data.vendor_response_status;

      // Prepare update object
      const updateObject = {};
      let shouldUpdate = false;

      // Check status update
      if (newStatus && newStatus.toLowerCase() !== order.vendor_status?.toLowerCase()) {
        updateObject.vendor_status = newStatus;
        shouldUpdate = true;
      }

      // Special handling for Awarded status
      if (newStatus && newStatus.toLowerCase() === 'awarded') {
        // Get current fulfillment status, defaulting to null if not exists
        const currentFulfillmentStatus = order.in_fulfillment_status 
          ? order.in_fulfillment_status.toLowerCase() 
          : null;

        // Conditions to set "In Progress"
        const shouldSetInProgress = 
          currentFulfillmentStatus === null || 
          currentFulfillmentStatus === 'not started';

        // Set in_fulfillment_status to 'In Progress' if conditions are met
        if (shouldSetInProgress) {
          updateObject.in_fulfillment_status = 'In Progress';
          shouldUpdate = true;
        }
      }

      // Perform update if changes detected
      if (shouldUpdate) {
        const updatedOrder = {
          ...order,
          ...updateObject
        };

        setOrder(updatedOrder);

        console.log('Order updated from notification:', {
          oldStatus: order.vendor_status,
          newStatus: newStatus,
          oldFulfillmentStatus: order.in_fulfillment_status,
          newFulfillmentStatus: updateObject.in_fulfillment_status,
          changes: Object.keys(updateObject)
        });
      }
    }
  }
}, [notifications, order]);
 */

//Checks the notification and if order id matches then fetch quotation by id will gets called.
useEffect(() => {
  // Check if we have notifications and an order
  if (notifications && notifications.length > 0 && order) {
    // Filter notifications that match the current order ID
    const matchingNotifications = notifications?.filter(notification =>
      notification?.data?.order_id?.replace(/"/g, '') === order?._id
    );

    // If we have matching notifications, fetch fresh data
    if (matchingNotifications.length > 0) {
      console.log('Found matching notification for current order, fetching fresh data:', {
        orderId: order._id,
        notificationCount: matchingNotifications.length,
        timestamp: new Date().toISOString()
      });
      
      // Fetch fresh data from server
      fetchQuotationbyId();
    }
  }
}, [notifications]);


/* const fetchQuotationbyId = async () => {
  try {
    setIsCounterOfferMode(false);
          setLoader(true);
      setLoadingProgress(0);
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    
    const token =  vendorData.token;
    
    // Fetch quotations for this vendor
   const response = await fetch(
  `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-suplier-quotation-by-its-id?quotation_id=${quotationId}&vendor_id=${vendorData.id}`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-token': token,
    },
  }
);

    const data = await response.json();
    console.log('Quotations data:', data);
          // Simulate network delay for better UX
      await new Promise(resolve => setTimeout(resolve, 1000));
    if (data.success) {
      // Update the orders state with the formatted data
      setOrder(data.data);
       setLoadingProgress(100);
      } else {
        console.error('Failed to fetch quotations');
      }
    } catch (error) {
      console.error('Error fetching quotations:', error);
    } finally {
      // Ensure loader is set to false
      setTimeout(() => {
        setLoader(false);
      }, 500);
    }
  }; */


const fetchQuotationbyId = async () => {
  try {
    setIsCounterOfferMode(false);
    setLoader(true);
    setLoadingProgress(0);

    const vendorDataString = localStorage.getItem("vendorData");
    if (!vendorDataString) return console.error("No vendor data found");

    const vendorData = JSON.parse(vendorDataString);
    const token = vendorData.token;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-supplier-rfq-details?rfq_response_id=${quotationId}&vendor_id=${vendorData.id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("Quotations data:", data);

    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (data.success) {
      setOrder(data.data);

      // ✅ set delivery included & time from backend
      
    // ✅ Handle delivery included mapping
if ("delivery_included" in data.data) {
  const included = data.data.delivery_included;

  if (included === true) {
    setDeliveryIncluded("Yes");
  } else if (included === false) {
    setDeliveryIncluded("No");
  } else {
    setDeliveryIncluded("Yes"); // fallback if null/invalid
  }
} else {
  setDeliveryIncluded("Yes"); // default if field is missing
}


      // ✅ handle delivery time (convert number → label)
      if (data.data.delivery_time_in_hours != null) {
        setDeliveryTime(data.data.delivery_time_in_hours);
      } else {
        setDeliveryTime(null);
      }

      setLoadingProgress(100);
    } else {
      console.error("Failed to fetch quotations");
    }
  } catch (error) {
    console.error("Error fetching quotations:", error);
  } finally {
    setTimeout(() => setLoader(false), 500);
  }
};


  // API function
  const fetchSimilarItemsbyVendor = async (itemid) => {
    //console.log('Fetching similar items for item ID:', itemid);
    try {
      const vendorDataString = localStorage.getItem('vendorData');
      if (!vendorDataString) {
        console.error('No vendor data found in localStorage');
        return [];
      }
      const vendorData = JSON.parse(vendorDataString);
      const response = await fetch(
        `${backendApiUrl}customer/rfq/get-similar-products-assined-to-supplier?supplier_id=${vendorData.id}&item_id=${itemid}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': vendorData.token,
          },
        }
      );
      const data = await response.json();
      console.log('Vendor items :', data);
      if (data.success) {
        return data.data;
      } else {
        console.error('Failed to fetch vendor items by category');
        return [];
      }
    } catch (error) {
      console.error('Error fetching vendor items by category:', error);
      return [];
    }
  };

  const handleSuggestAlternative = async () => {
      setLoadingItems(true);
      const items = await fetchSimilarItemsbyVendor(selectedItem.item_id);
      //console.log('Suggested items fetched:', items);
      setSuggestedItems(items);
      setLoadingItems(false);

    setIsBottomSheetOpen(false);
    setIsSuggestAlternativeOpen(true);
  };

   /*  const handleMarkNotAvailable = () => {
    if (selectedItem) {
      // Update the order data to mark the specific item as not available
      const updatedItems = order.items.map(item => {
        if (item.vendor_response_item_id === selectedItem.vendor_response_item_id) {
          return {
            ...item,
            not_available: true, // Add not_available flag
          };
        }
        return item;
      });

      // Update the order data state
      setOrder(prevOrderData => ({
        ...prevOrderData,
        items: updatedItems
      }));

      console.log('Marked item as not available:', selectedItem.item_name);
      console.log('Updated order data:', {
        ...order,
        items: updatedItems
      });

      // You can also make an API call here to update the backend
      // await updateOrderItemStatus(selectedItem.vendor_response_item_id, "not_available", true);
    }

    // Close the bottom sheet
    setIsBottomSheetOpen(false);
    
    // Optional: Show success message or update UI
    // alert(`"${selectedItem.item_name}" marked as not available`);
  }; */

const handleMarkNotAvailable = () => {
  if (selectedItem) {
    // Update the order data to mark the specific item as not available
    const updatedItems = order.items.map(item => {
      if (item.vendor_response_item_id === selectedItem.vendor_response_item_id) {
        return {
          ...item,
          not_available: true, // Add not_available flag
        };
      }
      return item;
    });

    // Calculate new order totals excluding not available items
    const availableItems = updatedItems.filter(item => !item.not_available);
    
    const newSubtotal = availableItems.reduce((sum, item) => sum + item.subtotal, 0);
    const newTaxAmount = availableItems.reduce((sum, item) => sum + item.calculated_tax_amount, 0);
    const newTotal = Math.round(newSubtotal + newTaxAmount); // Round to nearest integer

    // Update the order data state with recalculated totals
    setOrder(prevOrderData => ({
      ...prevOrderData,
      items: updatedItems,
      subtotal: Math.round(newSubtotal),
      tax_amount: Math.round(newTaxAmount),
      total: newTotal
    }));

    console.log('Marked item as not available:', selectedItem.item_name);
    console.log('Updated order data:', {
      ...order,
      items: updatedItems,
      subtotal: Math.round(newSubtotal),
      tax_amount: Math.round(newTaxAmount),
      total: newTotal
    });
  }

  // Close the bottom sheet
  setIsBottomSheetOpen(false);
};

  const handleBackFromSuggest = () => {
    setIsSuggestAlternativeOpen(false);
    setIsBottomSheetOpen(true);
  };


const handleDeliveryTimeChange = (time) => {
  const numericValue = parseInt(time);
  setDeliveryTime(numericValue); 
  
  console.log("User selected delivery time:", numericValue);
};



  // Add this handler for the Accept Order button
 // Add this function after the fetchQuotationbyId function
const updateVendorStatus = async (status, notes = '') => {
  // 🚨 validation before API call
 /*  if (!deliveryIncluded || !deliveryTime || parseInt(deliveryTime) === 0) {
    alert("Please select both 'Delivery Included?' and 'Delivery Time' before submitting.");
    return false; // stop execution
  } */
  try {    
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    const vendorResponse = await handleVendorResponseData(order, status, vendorData);
    console.log(order);
    console.log(vendorResponse);
    const token = vendorData.token;
    const vendor_id = vendorData.vendor_id || vendorData.id; // Adjust based on your vendor data structure
    
    // Call the update status API
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/submits-supplier-response-on-an-order?quotation_id=${order.quotation_id}`, 
      {
        method: 'PUT', // or 'PATCH' depending on your route
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          response_type: status,
          supplier_id: vendor_id,
          quotation_id:order.quotation_id,
          message: notes,
          delivery_included: deliveryIncluded === "Yes" ? true : false,
          delivery_time_in_hours: deliveryTime ? parseInt(deliveryTime) : null,
          vendor_response: vendorResponse,
          items_response: vendorResponse.items,
        })
      }
    );

    const data = await response.json();
    console.log('Status update response:', data);
    
    if (data.success) {
      // Refresh the quotation data to get updated status
      fetchQuotationbyId();
      return true;
    } else {
      console.error('Failed to update status:', data.message);
      return false;
    }
  } catch (error) {
    console.error('Error updating vendor status:', error);
    return false;
  }
};

// Older version that doesnt include items in the Accepted state
/* const handleVendorResponseData = async (order, status, vendorData) => {
  try {
    console.log('order:', order, 'status:', status);
    
    let items = [];
    let overallStatus = status;
    
    // Handle different status cases
    if (status === 'Accepted') {
      // For Accepted status: set all items to Accepted and return empty items array
      items = [];
      overallStatus = 'Accepted';
      
    } else if (status === 'Counter Offer') {
      // For Counter Offer: map items with proposed prices
      items = order.items.map(item => {
        const responseItem = {
          item_id: item.item_id || item._id,
          quantity: item.quantity,
          quotation_price: item.selling_price,
          item_status: 'Counter Offer',
          response_reason: 'Vendor proposed amendments to price/quantity'
        };
        
        // Add proposed price if it exists
        if (item.proposed_selling_price && item.proposed_selling_price !== item.selling_price) {
          responseItem.proposed_price = item.proposed_selling_price;
        }

        if (item.proposed_quantity && item.proposed_quantity !== item.quantity) {
          responseItem.quantity = item.proposed_quantity;
          responseItem.proposed_quantity = item.proposed_quantity;
        }
        
        return responseItem;
      });
      overallStatus = 'Counter Offer';
      
    } else if (status === 'rejected') {
      // For rejected status: map items with rejection reason
      items = order.items.map(item => ({
        item_id: item.item_id || item._id,
        quantity: item.quantity,
        quotation_price: item.selling_price,
        item_status: 'rejected',
        response_reason: 'Order rejected by vendor'
      }));
      overallStatus = 'rejected';
      
    } else if (status === 'Skipped') {
      // For skipped status: no need to process, return early or handle as needed
       items = [];
      overallStatus = 'Skipped';
      console.log('Order skipped by vendor');

    } else if (status === 'Shipped') {
      // For skipped status: no need to process, return early or handle as needed
       items = [];
      overallStatus = 'Shipped';
      console.log('Order Shipped');
    }
    
    // Create the vendor response data object
    const vendorResponseData = {
      quotation_id: order._id || quotationId,
      vendor_id: vendorData.vendor_id || vendorData.id,
      status_updated_at: new Date(),
      items: items,
      status: overallStatus
    };
    
    console.log('Vendor Response Data:', vendorResponseData);
    return vendorResponseData;
    
  } catch (error) {
    console.error('Error creating vendor response data:', error);
    return null;
  }
}; */

const handleVendorResponseData = async (order, status, vendorData) => {
  try {
    console.log('order:', order, 'status:', status);

    let items = [];
    let overallStatus = status;

    if (status === 'Accepted') {
      // ✅ ACCEPTED
      items = order.items.map(item => {
        const responseItem = {
          item_id: item.item_id || item._id,
          quantity: item.quantity,
          quotation_price: item.selling_price,
          item_status: 'Accepted',
          response_reason: 'Order accepted by vendor',
          not_available: item.not_available || false
        };

        if (item.proposed_item_id) {
          responseItem.proposed_item_id = item.proposed_item_id;
        }

        return responseItem;
      });

      overallStatus = 'Accepted';

    } else if (status === 'Counter Offer') {
      // ✅ COUNTER OFFER (MAIN FIX)
      items = order.items.map(item => {
        const responseItem = {
          item_id: item.item_id || item._id,

          // ✅ USE PROPOSED QUANTITY IF AVAILABLE
          quantity: item.proposed_quantity
            ? item.proposed_quantity
            : item.quantity,

          // ✅ SEND COUNTER PRICE IN quotation_price
          quotation_price: item.selling_price,
          proposed_price: item.proposed_selling_price,

          item_status: 'Counter Offer',
          response_reason: 'Vendor proposed amendments to price/quantity',
          not_available: item.not_available || false
        };

        // ✅ KEEP ALTERNATE ITEM IF EXISTS
        if (item.proposed_item_id) {
          responseItem.proposed_item_id = item.proposed_item_id;
        }

        return responseItem;
      });

      overallStatus = 'Counter Offer';

    } else if (status === 'rejected') {
      // ❌ REJECTED
      items = order.items.map(item => ({
        item_id: item.item_id || item._id,
        quantity: item.quantity,
        quotation_price: item.selling_price,
        item_status: 'rejected',
        response_reason: 'Order rejected by vendor',
        not_available: item.not_available || false
      }));

      overallStatus = 'rejected';

    } else if (status === 'Skipped') {
      items = [];
      overallStatus = 'Skipped';
      console.log('Order skipped by vendor');

    } else if (status === 'Shipped') {
      items = [];
      overallStatus = 'Shipped';
      console.log('Order shipped');
    }

    const vendorResponseData = {
      quotation_id: order._id || quotationId,
      vendor_id: vendorData.vendor_id || vendorData.id,
      status_updated_at: new Date(),
      items: items,
      status: overallStatus
    };

    console.log('Vendor Response Data:', vendorResponseData);
    return vendorResponseData;

  } catch (error) {
    console.error('Error creating vendor response data:', error);
    return null;
  }
};


const handleAcceptOrder = async() => {
  /* if (!deliveryIncluded || !deliveryTime || parseInt(deliveryTime) === 0) {
      setShowValidationModal(true); // Show modal instead of alert
       return false
    } */
 setShowConfirmationModal(true); }
// Update the handleAcceptOrder function
const handleConfirmResponse = async (forcedStatus) => {
  let status, notes;

  if (forcedStatus === 'Counter Offer') {
    status = 'Counter Offer';
    notes = 'Order Proposed by vendor';
  } else {
    status = 'Accepted';
    notes = priceValidityOption;
  }

  const success = await updateVendorStatus(status, notes);

  if (success) {
    setIsCounterOffer(false);
    setIsCounterOfferMode(false);
    setOrderAccepted(true);
  }
};



const handlePriceValiditySubmit = () => {
  if (priceValidityOption) {
    // Process the selected option
    console.log('Selected Price Validity:', priceValidityOption);
    // setPriceValidityModalOpen(false);
  } else {
    // Optional: Show an error or prevent submission
    alert('Please select a price validity option');
  }
}; 

// Add handlers for other buttons
const handleRejectOrder = async () => {
  const success = await updateVendorStatus('rejected', 'Order rejected by vendor');
  if (success) {
    // Maybe navigate back or show rejection confirmation
    alert('Order rejected successfully');
  } else {
    alert('Failed to reject order. Please try again.');
  }
};

const fetchAllUOMs = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${backendApiUrl}UOMs/get-all-UOMs`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    //console.log('Fetched UOMs:', data);

    if (data.status === 200 || data.status === 201) {
      setAllUOMs(data.data);
    } else {
      console.error("Failed to fetch UOMs:", data.message);
    }
  } catch (error) {
    console.error("Error fetching UOMs:", error);
  }
};

const handleSkipOrder = async () => {
 setSkipOrderReasonsModal(true);
};

const handleItemsReadyConfirmation = async () => {
 setItemsReadyPopup(true);
};
      

  // Function to update item price using INDEX
/*   const updateItemPrice = (index, newPrice) => {
  const updatedItems = [...amendedItems];
  updatedItems[index] = {
    ...updatedItems[index],
    proposed_selling_price: newPrice,
    proposed_total: newPrice * (updatedItems[index].proposed_quantity || updatedItems[index].quantity)
  };
  setAmendedItems(updatedItems);
  const UpdatedOrderData = {...order};
  UpdatedOrderData.items[index].proposed_selling_price = newPrice;
  
  // Use proposed_quantity if available, otherwise use quantity
  const quantity = UpdatedOrderData.items[index].proposed_quantity || UpdatedOrderData.items[index].quantity;
  UpdatedOrderData.items[index].proposed_total = newPrice * quantity;
  
  // Calculate subtotal using proposed values or fallback to original values
  UpdatedOrderData.subtotal = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotal = item.proposed_total || (itemQuantity * itemPrice);
    return sum + itemTotal;
  }, 0);

    UpdatedOrderData.tax_amount = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotaltax = itemQuantity * itemPrice * item.tax_rate / 100;
    return sum + itemTotaltax;
  }, 0);
  
  // Calculate total (subtotal + tax)
  UpdatedOrderData.total = UpdatedOrderData.subtotal + UpdatedOrderData.tax_amount;
  console.log('Updated Order Data:', UpdatedOrderData);
   console.log('Updated items Data:', updatedItems);
  setOrder(UpdatedOrderData);
  
}; */

const updateItemPrice = (itemId, newPrice) => {
  const updatedItems = amendedItems.map(item => {
    if (item.item_id === itemId) {
      return {
        ...item,
        proposed_selling_price: newPrice,
        proposed_total: newPrice * (item.proposed_quantity || item.quantity)
      };
    }
    return item;
  });
  setAmendedItems(updatedItems);
};

  // Calculate total for amended order
  const calculateAmendedTotal = () => {
    const subtotal = amendedItems.reduce((sum, item) => 
      sum + (item.proposed_total || 0), 0);
    const taxRate = order?.tax_amount / order?.subtotal || 0.18; // Default to 18% if not found
    const taxAmount = subtotal * taxRate;
    
    return {
      subtotal,
      taxAmount,
      total: subtotal + taxAmount
    };
  };


// Function to update quantity
const updateCounterOfferQuantity = (index, change) => {
  const updatedItems = [...amendedItems];
  const currentQuantity = updatedItems[index].proposed_quantity;

  const maxQuantity = updatedItems[index].quantity; // Optional: restrict max if needed
  const newQuantity = Math.min(maxQuantity, Math.max(0, currentQuantity + change));

  updatedItems[index] = {
    ...updatedItems[index],
    proposed_quantity: newQuantity,
    proposed_total: newQuantity * updatedItems[index].proposed_selling_price
  };
  
  setAmendedItems(updatedItems);

    /* const UpdatedOrderData = {...order};
    const currentOrderQuantity = UpdatedOrderData.items[index].proposed_quantity;
    const newOrderQuantity = Math.max(1, currentOrderQuantity + change);
      UpdatedOrderData.items[index] = {
    ... UpdatedOrderData.items[index],
    proposed_quantity: newOrderQuantity,
    proposed_total: newOrderQuantity * UpdatedOrderData.items[index].proposed_selling_price
      };
       // Calculate subtotal using proposed values or fallback to original values
  UpdatedOrderData.subtotal = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotal = item.proposed_total || (itemQuantity * itemPrice);
    return sum + itemTotal;
  }, 0);

    UpdatedOrderData.tax_amount = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotaltax = itemQuantity * itemPrice * item.tax_rate / 100;
    return sum + itemTotaltax;
  }, 0);
  
  // Calculate total (subtotal + tax)
  UpdatedOrderData.total = UpdatedOrderData.subtotal + UpdatedOrderData.tax_amount;
  console.log('Updated Order Data:', UpdatedOrderData);
   console.log('Updated items Data:', updatedItems); */
 
  //setOrder(UpdatedOrderData);
};


 const handleProposeAmendments = () => {
  /* if (!deliveryIncluded || !deliveryTime || parseInt(deliveryTime) === 0) {
      setShowValidationModal(true); // Show modal instead of alert
       return false
    } */
  // Initialize amended items with the current order items
  if (order && order.items) {
 setAmendedItems(order.items.map(item => ({
     ...item,
   proposed_quantity: item.quantity,
   proposed_selling_price: item.selling_price,
   proposed_total: item.quantity * item.selling_price
})));


 const UpdatedOrderData = {
    ...order,
 items: order.items.map(item => ({
    ...item,
 proposed_quantity: item.quantity,
 proposed_selling_price: item.selling_price,
 proposed_total: item.quantity * item.selling_price
 }))
};
setOrder(UpdatedOrderData);


 //setIsProposingAmendments(true);
 setIsCounterOfferModalOpen(true);
 }
 };

 // Contains older version of handleSaveAmendments and calculateUpdateOrder without not_available handling
/* const handleSaveAmendments= async() =>{
  const updateOrder = {...order};
  updateOrder.items = amendedItems;
 const FinalOrder= await calculateUpdateOrder(updateOrder);
 await setOrder(FinalOrder);
 console.log('Updated Order Data:', FinalOrder);
 if(FinalOrder){
  setIsCounterOfferModalOpen(false);
   setIsCounterOfferMode(true);
 }
}

const calculateUpdateOrder = (updateOrder) => {
  // Calculate updated items with individual totals
  const updatedItems = updateOrder.items.map((item, index) => {
    const price =  item.proposed_selling_price > 0 ? item.proposed_selling_price : item.selling_price
    const quantity = item.proposed_quantity > 0 ? item.proposed_quantity : item.quantity
    const total_tax_amount = (item.tax_rate * price * quantity) / 100;
    
    return {
      ...item,
      total_tax_amount: Math.round(total_tax_amount),
      subtotal: Math.round(price* quantity),
      total: Math.round(price * quantity + total_tax_amount)
    };
  });
  
  // Calculate order-level totals
  const orderSubtotal = updatedItems.reduce((sum, item) => {
    return sum + item.subtotal;
  }, 0);
  
  const orderTaxAmount = updatedItems.reduce((sum, item) => {
    return sum + item.total_tax_amount;
  }, 0);
  
  const orderTotal = orderSubtotal + orderTaxAmount;
  
  // Return the complete updated order
  return {
    ...updateOrder,
    items: updatedItems,
    subtotal: Math.round(orderSubtotal),
    tax_amount: Math.round(orderTaxAmount),
    total: Math.round(orderTotal)
  };
}; */


const calculateUpdateOrder = (updateOrder) => {
  // Filter out not available items for calculation
  const availableItems = updateOrder.items.filter(item => !item.not_available);
  
  // Calculate updated items with individual totals
  const updatedItems = updateOrder.items.map((item) => {
    // If item is not available, set all values to 0
    if (item.not_available) {
      return {
        ...item,
        total_tax_amount: 0,
        subtotal: 0,
        total: 0
      };
    }
    
    // For available items, calculate normally
    const price = item.proposed_selling_price > 0 ? item.proposed_selling_price : item.selling_price;
    const quantity = item.proposed_quantity > 0 ? item.proposed_quantity : item.quantity;
    const total_tax_amount = (item.tax_rate * price * quantity) / 100;
    
    return {
      ...item,
      total_tax_amount: Math.round(total_tax_amount),
      subtotal: Math.round(price * quantity),
      total: Math.round(price * quantity + total_tax_amount)
    };
  });
  
  // Calculate order-level totals using only available items
  const orderSubtotal = availableItems.reduce((sum, item) => {
    const price = item.proposed_selling_price > 0 ? item.proposed_selling_price : item.selling_price;
    const quantity = item.proposed_quantity > 0 ? item.proposed_quantity : item.quantity;
    return sum + Math.round(price * quantity);
  }, 0);
  
  const orderTaxAmount = availableItems.reduce((sum, item) => {
    const price = item.proposed_selling_price > 0 ? item.proposed_selling_price : item.selling_price;
    const quantity = item.proposed_quantity > 0 ? item.proposed_quantity : item.quantity;
    const total_tax_amount = (item.tax_rate * price * quantity) / 100;
    return sum + Math.round(total_tax_amount);
  }, 0);
  
  const orderTotal = orderSubtotal + orderTaxAmount;
  
  // Return the complete updated order
  return {
    ...updateOrder,
    items: updatedItems,
    subtotal: Math.round(orderSubtotal),
    tax_amount: Math.round(orderTaxAmount),
    total: Math.round(orderTotal)
  };
};

const handleSaveAmendments = async () => {
  const updateOrder = {...order};
  updateOrder.items = amendedItems;
  const FinalOrder = await calculateUpdateOrder(updateOrder);
  await setOrder(FinalOrder);
  console.log('Updated Order Data:', FinalOrder);
  if(FinalOrder){
    setIsCounterOfferModalOpen(false);
    setIsCounterOfferMode(true);
  }
}
const SaveProposedAmmendments = async () => {
  // Close Counter Offer Modal
  setIsCounterOfferModalOpen(false);
  
  // Open Price Validity Modal for Counter Offer
  // setPriceValidityModalOpen(true);
  
  // Set a flag to indicate this is a counter offer
  await handleConfirmResponse('Counter Offer');

};



// Add a handler for withdrawing acceptance
const handleWithdrawAcceptance = async () => {
  setIsWithdrawModalOpen(false);
};

const handleSkipOrderSubmit = () => {
  if (selectedSkipReason) {
    // Perform skip order logic here
    console.log('Skipping order with reason:', selectedSkipReason);
    updateVendorStatus('Skipped', selectedSkipReason );
    // Close the modal
    setSkipOrderReasonsModal(false);

    // Reset selected reason
    setSelectedSkipReason(null);
    // Reset selected reason
  }
};

const handleItemsReady = async () => {
  try {
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return false;
    }

    const vendorData = JSON.parse(vendorDataString);
    const status = 'Items Ready'; // Explicitly set status

    const token = vendorData.token;
    const vendor_id = vendorData.vendor_id || vendorData.id; // Adjust based on your vendor data structure

    // Call the update status API
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-fulfillment-status`,
      {
        method: 'PUT', // or 'PATCH' depending on your route
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          in_fulfillment_status: status,
          vendor_id: vendor_id,
          quotation_id: quotationId,
        })
      }
    );

    const data = await response.json();
    console.log('Status update response:', data);

    if (data.success) {
      // Refresh the quotation data to get updated status
      await fetchQuotationbyId();
      
      // Close the items ready popup
      setItemsReadyPopup(false);
      
      return true;
    } else {
      console.error('Failed to update status:', data.message);
      return false;
    }
  } catch (error) {
    console.error('Error updating vendor status:', error);
    return false;
  }
};

// Add this useEffect after your existing useEffects
// Update your useEffect
useEffect(() => {
  // Check if quotationIdFromQuery exists and order is awarded
  if (quotationIdFromQuery && order && order.vendor_status === 'Awarded' && order.in_fulfillment_status === 'Items Ready') {
    setIsUpdatingDeliveryStatus(true);
    handleDeliveryPartnerAssigned();
  }
}, [quotationIdFromQuery, order?.vendor_status, order?.in_fulfillment_status]);


// Add this new function to handle delivery partner assignment

// Update your handleDeliveryPartnerAssigned function
const handleDeliveryPartnerAssigned = async () => {
  try {
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      setIsUpdatingDeliveryStatus(false);
      return false;
    }

    const vendorData = JSON.parse(vendorDataString);
    const status = 'Delivery Partner Assigned';
    const token = vendorData.token;
    const vendor_id = vendorData.vendor_id || vendorData.id;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-fulfillment-status`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          in_fulfillment_status: status,
          vendor_id: vendor_id,
          quotation_id: quotationId,
        })
      }
    );

    const data = await response.json();
    console.log('Delivery Partner Assignment response:', data);

    if (data.success) {
      await fetchQuotationbyId();
      setIsUpdatingDeliveryStatus(false);
      return true;
    } else {
      console.error('Failed to update delivery partner status:', data.message);
      setIsUpdatingDeliveryStatus(false);
      return false;
    }
  } catch (error) {
    console.error('Error updating delivery partner status:', error);
    setIsUpdatingDeliveryStatus(false);
    return false;
  }
};



const HandleWindowLoad = () => {
  window.location.reload();  
}

// OTP handling functions
const handleOTPChange = (index, value) => {
  // Only allow numeric input
  if (!/^\d*$/.test(value)) return;
  
  const newOtpValues = [...otpValues];
  newOtpValues[index] = value;
  setOtpValues(newOtpValues);
  
  // Auto-focus next input
  if (value && index < 3) {
    otpRefs[index + 1].current?.focus();
  }
};

const handleOTPKeyDown = (index, e) => {
  // Handle backspace to move to previous input
  if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
    otpRefs[index - 1].current?.focus();
  }
};

const handleVerifyOTP = async () => {
  const otpString = otpValues.join('');
  
  if (otpString.length !== 4) {
    alert('Please enter a complete 4-digit OTP');
    return;
  }
  
  setIsVerifyingOTP(true);
  
  try {
    // Add your OTP verification API call here
    const vendorDataString = localStorage.getItem('vendorData');
    const vendorData = JSON.parse(vendorDataString);
    
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-fulfillment-status`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': vendorData.token,
        },
        body: JSON.stringify({
          quotation_id: quotationId,
          vendor_id:  vendorData.id,
          in_fulfillment_status: 'Order Items Picked Up',
        })
      }
    );
    
    const data = await response.json();
    
    if (data.success) {
      // Close modal and refresh order data
      setIsOTPModalOpen(false);
      setOtpValues(['', '', '', '']);
      await fetchQuotationbyId();
      alert('OTP verified successfully!');
    } else {
      alert(data.message || 'Invalid OTP. Please try again.');
    }
  } catch (error) {
    console.error('Error verifying OTP:', error);
    alert('Error verifying OTP. Please try again.');
  } finally {
    setIsVerifyingOTP(false);
  }
};

const closeOTPModal = () => {
  setIsOTPModalOpen(false);
  setOtpValues(['', '', '', '']);
};


// Create a skeleton loader component for this specific case
const DeliveryStatusSkeleton = () => (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    <div className="w-full p-4 flex items-center justify-between animate-pulse">
      <div className="w-[75%] space-y-2">
        <div className="h-3 bg-gray-200 rounded w-3/4"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
      </div>
      <div className="w-[35%]">
        <div className="h-8 bg-gray-200 rounded-md"></div>
      </div>
    </div>
  </div>
);

  const isEditable = order?.vendor_status === 'Respond Now' && !isExpired && !isCounterOfferMode;


return (
     <div className="flex flex-col min-h-screen bg-[#f5f5f5]">
         {/* Loader Components */}
      {loader && (
        <>
          <ProgressLoader progress={loadingProgress} />
          {loadingProgress < 50 ? <LoadingSpinner /> : <OrderDetailsSkeleton />}
        </>
      )}
           {/* <SupplierHeader /> */}
             {!loader && (
        <>
    <div className="sticky top-0 z-50 bg-white h-14 shadow-md px-1 flex items-center">

  {/* Back Button */}
 <button
  onClick={() => navigate(-1)}
  className="active:scale-90 transition"
>
  <img
    src={ArrowLeft}
    alt="Back"
    className="h-8 w-12"
  />
</button>


  {/* Title */}
  <p className="text-lg font-semibold text-gray-800">
    RFQ Details
  </p>

</div>

{/*           
         <div className='p-2 w-full flex justify-end'>
                  <LanguageSelector />
                </div> */}
    
    {/* Main Content */}

    
   <div className="p-4 mb-4">

{order && order?.vendor_status === 'Respond Now' && !isExpired && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100 p-3">
    <div className="flex items-center ">
      <div className="flex-shrink-0">
        <img
          src={BoxHourGlass}
          alt="Order waiting"
          className='px-2 py-1 rounded-lg w-10 h-10 object-cover bg-[#FFECEA]'
        />
      </div>
      <div className="ml-3 flex-1 min-w-0">
        <h3 className="text-md font-semibold text-gray-900 leading-tight">
           {order.rfq_number}
        </h3>
        <p className="text-md font-medium text-[#524D4D] mt-0.5">Respond Now</p>
      </div>
      <div className="flex flex-col items-center ">
        <p className='font-medium'>Closes in</p>
        <div className="flex items-center space-x-1">
          <div className="border border-[#E0D9D9] px-3 py-1 rounded flex flex-col items-center">
            <span className="text-[#170101] font-bold text-sm">
              {timeRemaining?.minutes ?? '--'}
            </span>
            <span className="font-medium text-[#524D4D] text-xs">mins</span>
          </div>
          <div className="font-bold">:</div>
          <div className="border border-[#E0D9D9] px-3 py-1 rounded flex flex-col items-center">
            <span className="text-[#170101] font-bold text-sm">
              {timeRemaining?.seconds != null
                ? (timeRemaining.seconds < 10 ? `0${timeRemaining.seconds}` : timeRemaining.seconds)
                : '--'}
            </span>
            <span className="font-medium text-[#524D4D] text-xs">sec</span>
          </div>
        </div>
      </div>
    </div>
  </div>
)}


{order && order?.vendor_status === 'Closed' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    <div className="p-4 flex flex-col space-y-4">
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className="font-medium text-black">
          {order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Closed
        </span>
      </div>
      <div className="flex items-center space-x-4">
        <img
          src={Boxx}
          alt="Order confirmed"
          className="pr-1 w-16 h-16 bg-[#F2F5F7] rounded-lg object-cover"
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Sorry!
          </h2>
          <p className="font-medium text-sm text-[#524D4D] leading-snug">
            Another seller got this order. As they responded quicker. Better luck next time.
          </p>
        </div>
      </div>
    </div>
  </div>
)}


 {/* Accepted  */}
   {order && order.vendor_status === 'Accepted' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
         {order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          {order.vendor_status.toUpperCase()}
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={BoxCheck}
          alt="Order confirmed"
          className="w-16 h-16 bg-[#E7FAD5] rounded-lg object-contain "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Thanks for Responding!
          </h2>
          <p className="font-medium text-sm text-[#524D4D] leading-snug">
            You’ll be notified if this order is awarded to you. 
            Waiting for buyer confirmation.
          </p>
        </div>
      </div>
    </div>
  </div>
)}

 {/* Skipped or Rejected  */}
   {order && order.vendor_status === 'Skipped' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
          {order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Skipped
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={BoxArrow}
          alt="Order confirmed"
          className="w-16 h-16 bg-[#F4F1F1] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            You have Skipped
          </h2>
          <p className="font-medium text-xs text-[#524D4D] leading-snug">
            You won’t be able to accept or give a counter offer on this order anymore.
          </p>
        </div>
      </div>
    </div>
  </div>
)}


 {/* Counter Offer  */}
   {order && order.vendor_status === 'Counter Offer' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
          {order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Counter Offer Submitted
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={CounterOffer}
          alt="Order confirmed"
          className="w-16 h-16 bg-[#E7FAD5] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Waiting for Buyer Response
          </h2>
          <p className="font-medium text-sm text-[#524D4D] leading-snug">
            You will be awarded the order if the buyer comfirms your counter offer.
          </p>
        </div>
      </div>
    </div>
  </div>
)}

 {/* Not Awarded  */}
   {order && order.vendor_status === 'Not Awarded' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
          {order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Not Awarded
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={Boxx}
          alt="Order confirmed"
          className="pr-1 w-16 h-16 bg-[#F2F5F7] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Sorry!
          </h2>
          <p className="font-medium text-xs text-[#524D4D] leading-snug">
            Another seller got this order. Your price was a little higher or they responded quicker. Better luck next time.
          </p>
        </div>
      </div>
    </div>
  </div>
)}

 {/* Awarded starts  */}
 {order && 
 order.vendor_status === 'Awarded' && 
 (order.in_fulfillment_status === 'In Progress' || order.in_fulfillment_status === 'Delivery Partner Assigned' || order.in_fulfillment_status === 'Not Started'
 || order.in_fulfillment_status === 'Items Ready')
  && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between items-center border-b border-[#F1E9E9] pb-2">
  {/* Left side */}
  <div>
    {/* RFQ number */}
    <p className="font-medium text-black">
       {order.rfq_number}
    </p>

    {/* List all sub-order numbers */}

  </div>

  {/* Right side */}
  <div className='flex flex-col justify-center items-center '>
  <span className="text-base font-semibold text-[#524D4D]">
    {order?.status}
  </span>
      {order?.purchase_orders?.map((po) => (
      <p key={po.purchase_order_id} className="underline decoration-dotted decoration-blue-600 text-sm text-blue-600">
  {po.sub_order_number}
</p>
    ))}
    </div>
</div>


      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={Medal}
          alt="Order confirmed"
          className="pr-1 w-16 h-16 bg-[#FFF5C5] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Congratulations!
          </h2>
          <p className="font-medium text-xs text-[#524D4D] leading-snug">
            This order is yours. Please get the items ready for pickup by our delivery partner.
          </p>
        </div>
      </div>
    </div>
  </div>
)}

{order && 
 order.vendor_status === 'Awarded' && 
 order.in_fulfillment_status === 'In Progress' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    <div className="p-4 flex items-center justify-between">
      <p className="text-base text-sm font-bold text-[#524D4D]">
        Are order items ready for pickup?
      </p>
      <button 
        onClick={handleItemsReadyConfirmation}
        className="px-4 py-1 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold rounded-md transition"
      >
        Yes
      </button>
    </div>
  </div>
)}



{order && order.vendor_status === 'Awarded' && (
  <>
    {/* Show skeleton when updating delivery status */}
    {isUpdatingDeliveryStatus && <DeliveryStatusSkeleton />}
    
    {/* Items Ready status - hide when updating */}
    {!isUpdatingDeliveryStatus && order.in_fulfillment_status === 'Items Ready' && (
      <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
        <div className="p-4 flex flex-row items-center justify-between">
          <img
            src={Scooter}
            alt="Order confirmed"
            className="w-20 h-10 md:h-20 md:w-40 rounded-lg object-cover"
          />
          <p className=" text-base text-xs font-bold text-[#524D4D]">
            Delivery Partner notified for order pickup and will be arriving soon!
          </p>
        </div>
      </div>
    )}
    
    {/* Delivery Partner Assigned status */}
    {!isUpdatingDeliveryStatus && order.in_fulfillment_status === 'Delivery Partner Assigned' && (
      <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
        <div className="w-full p-4 flex items-center justify-between">
          <p className="w-[75%] text-base text-xs font-bold text-[#524D4D]">
            Get OTP from delivery partner to confirm order items pickup
          </p>
          <button
        onClick={() => setIsOTPModalOpen(true)}
        className="w-[35%] px-4 py-2 bg-red-500 hover:bg-red-600 text-white text-xs font-semibold rounded-md transition"
      >
        Verify OTP
      </button>
        </div>
      </div>
    )}
  </>
)}


 {/* Awarded  ends */}


 {/* Shipped  Starts */}
   {order && order.vendor_status === 'Awarded' && 
   order.in_fulfillment_status === 'Order Items Picked Up' &&
   (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
           #{order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Shipped
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={Shipped}
          alt="Order confirmed"
          className="pr-1 w-16 h-16 bg-[#EFFAFF] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Order Shipped!
          </h2>
          <p className="font-medium text-xs text-[#524D4D] leading-snug">
You have given the order Items to our delivery partner.          </p>
        </div>
      </div>
    </div>
  </div>
)}

 {/* Items Return */}
   {order && order.vendor_status === 'Returning' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
          #{order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Returned
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={BoxReturn}
          alt="Order confirmed"
          className="pr-1 w-16 h-16 bg-[#F8EADA] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Items Returning
          </h2>
          <p className="font-medium text-xs text-[#524D4D] leading-snug">
The Buyer has returning some of the items delivered. They will be returned to you shortly   
      </p>
        </div>
      </div>
    </div>
  </div>
)}


   {order && order.vendor_status === 'returned' && (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    {/* Card content container with padding */}
    <div className="p-4 flex flex-col space-y-4">
      
      {/* Header: Quotation & Status */}
      <div className="flex justify-between border-b border-[#F1E9E9] pb-2">
        <p className=" font-medium text-black">
          #{order.rfq_number}
        </p>
        <span className="text-base font-semibold text-[#524D4D]">
          Returned
        </span>
      </div>

      {/* Main content: Image + Text */}
      <div className="flex items-center space-x-4">
        <img
          src={BoxReturn}
          alt="Order confirmed"
          className="pr-1 w-16 h-16 bg-[#F8EADA] rounded-lg object-cover "
        />
        <div className="flex-1 space-y-1">
          <h2 className="text-lg font-semibold text-[#524D4D] leading-snug">
            Return Confirmed
          </h2>
          <p className="font-medium text-sm text-[#524D4D] leading-snug">
The Delivery partner has returned the items to you.      </p>
        </div>
      </div>
    </div>
  </div>
)}




<div className='rounded-md  mt-2 flex flex-col'>
  {/* First Div: Order Header */}
  {order?.order_numbers && order.order_numbers.length > 0 && (
   <div className="bg-white px-4 py-3 border border-gray-200 rounded-lg 
                flex flex-row items-center justify-between mb-2">

    {/* LEFT SIDE */}
    <h2>Order Number</h2>

    {/* RIGHT SIDE (Clickable Order No) */}
    <h2
        onClick={() => {
            const finalOrderId = order.order_numbers[0].order_id;
            console.log("NAVIGATING WITH CORRECT ORDER ID:", finalOrderId);

            navigate(`/supplier/orderdetails`, {
                state: {
                    quotationId: finalOrderId,
                    vendor_id: order.vendor_id,
                }
            });
        }}
     className="underline decoration-dotted cursor-pointer font-medium"
    style={{ color: "#1E3A8A" }}
>
    {order.order_numbers[0].order_no}
</h2>
</div>

)}
         
      

  {/* Second Div: Categories and Items */}
  <div>
  {order ? (
    // Group items by category
    (() => {
      const itemsToDisplay = isProposingAmendments ? order?.items : order?.items;
      const groupedItems = itemsToDisplay?.reduce((acc, item) => {
        const category = item.item_category_name || 'Uncategorized';
        if (!acc[category]) acc[category] = [];
        acc[category].push(item);
        return acc;
      }, {});
      
      return Object.keys(groupedItems).map((category) => (
        <div key={category} className='shadow-md bg-white rounded-md flex flex-col mb-4'>
          {/* Category Header */}
          <div className='border-b border-gray-200 bg-white w-full px-4 py-2 mt-2 mb-2 text-sm font-semibold text-gray-700 rounded-md'>
            <span>{category}</span>
          </div>
          {/* Items in this category */}
          {groupedItems[category].map((item, index) => (
            <div 
              key={item.item_id || index} 
              className={`border-b border-gray-100 ${item.not_available ? 'bg-gray-50 opacity-60' : 'bg-white'} ${index === groupedItems[category].length - 1 ? 'border-b-0' : ''}`}
            >
              <div className='flex items-start p-4 space-x-4 relative'>
                {/* Gray overlay for not available items */}
                {item.not_available && (
                  <div className="absolute inset-0 bg-gray-100 bg-opacity-50 rounded-md"></div>
                )}
                
                {/* Image - Fixed Left */}
                <div className='flex-shrink-0 relative '>
                  <div className={`w-12 h-12 border rounded-md overflow-hidden flex items-center justify-center ${
                    item.not_available ? 'bg-gray-100 border-gray-300' : 'bg-gray-50 border-gray-200'
                  }`}>
                    <img
                      src={
                        item.item_image
                          ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.item_image}`.trim()
                          : Default
                      }
                      alt={item.item_name || 'Product'}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentNode.innerHTML =
                          '<span class="text-gray-400 text-[10px] text-center">No Image</span>';
                      }}
                      className={`object-contain w-full h-full ${item.not_available ? 'opacity-50' : ''}`}
                    />
                  </div>
                </div>

                {/* Item Details */}
                <div className='flex-grow min-w-0 relative '>
                  <h1 className={`text-sm font-medium line-clamp-2 mb-1 ${
                    item.not_available ? 'text-gray-500' : 'text-gray-900'
                  }`}>
                    {item?.item_name}
                  </h1>

                  <div className='mt-1 flex flex-row'>
                    <p className={`mt-0.5 text-xs font-medium ${
                      item.not_available ? 'text-gray-400' : 'text-gray-500'
                    }`}>
                     ₹{Number(item.proposed_selling_price || item.selling_price || item.proposed_price).toLocaleString("en-US")}
                    </p>
                    <p className={`text-xs mx-2 ${
                      item.not_available ? 'text-gray-400' : 'text-gray-500'
                    }`}>x</p>
                    <p className={`mt-0.5 text-xs font-medium ${
                      item.not_available ? 'text-gray-400' : 'text-gray-500'
                    }`}>
                      {item?.proposed_quantity || item?.quantity} qty
                    </p>
                  </div>
                </div>

                {/* Price Details */}
                <div className='flex-shrink-0 text-right relative '>
                  {isProposingAmendments ? (
                    <input
                      type='number'
                      value={item.proposed_selling_price || item.selling_price}
                      onChange={(e) => updateItemPrice(index, parseFloat(e.target.value))}
                      className={`w-24 border rounded px-2 py-1 text-right text-sm ${
                        item.not_available ? 'bg-gray-100 border-gray-300 text-gray-500' : ''
                      }`}
                      min='0'
                      step='0.01'
                      disabled={item.not_available}
                    />
                  ) : (
                    <>
                      <p className={`text-md font-semibold ${
                        item.not_available ? 'text-gray-400 line-through' : 'text-gray-900'
                      }`}>
                       ₹{Number(item.subtotal).toLocaleString("en-US")}
                      </p>
                      
                      {order && order?.vendor_status === 'Respond Now' && !isExpired && !item.not_available && (
                        <button 
                          onClick={() => {
                            setIsBottomSheetOpen(true);
                            setSelectedItem(item);
                          }}
                          className='font-semibold rounded-sm p-0.5 text-xs mt-1 border-b-2 border-dashed border-red-500 text-red-500 hover:bg-red-50 transition-colors'
                        >
                          Item Not Available 
                        </button>
                      )}
                      
                      {/* Show different text if item is already marked as not available */}
                      {item.not_available && (
                        <div className="flex items-center justify-end mt-1">
                          <span className="text-red-600 text-xs font-medium bg-red-50 px-2 py-1 rounded border border-red-200">
                            Not available
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ));
    })()
  ) : null}
</div>



  {/* Amended Total Calculation Section */}
  {isProposingAmendments && (
    <div className='p-4 bg-white'>
      <div className='grid grid-cols-1 gap-1'>
        <div className='flex flex-row justify-between items-center'>
          <p className='text-sm'>Items Total</p>
          <p>₹{calculateAmendedTotal().subtotal.toLocaleString()}</p>
        </div>
        <div className='flex flex-row justify-between items-center'>
          <p className='text-sm'>GST(18%)</p>
          <p>₹{calculateAmendedTotal().taxAmount.toLocaleString()}</p>
        </div>
        <div className='border-b-2 border-gray-100'></div>
        <div className='flex flex-row justify-between items-center'>
          <p className='text-md font-medium'>Grand Total</p>
          <p className='text-md'>
            ₹{calculateAmendedTotal().total.toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  )}
</div>
{/* Delivery distance info and delivery time */}

<div className={`bg-white rounded-lg shadow-sm p-4 mt-2 ${!isEditable ? "opacity-50 pointer-events-none" : ""}`}>
  {/* Header */}
  <div className="flex items-center justify-between mb-1">
    <div className="flex items-start flex-col">
      <h2 className="text-lg font-medium text-gray-800  mb-1">Delivery Details</h2>
    </div>
  </div>

  {/* Delivery Point row: icon left, texts right */}
{(order?.project_location?.area || order?.distance_from_delivery_location_km) && (
  <div className="">
    <div className="flex-row items-center ">
      <FontAwesomeIcon icon={faMapMarkerAlt} size={14} color="#6B7280" />
      <span className="ml-2 text-[12px] font-medium text-gray-600">
        Delivery Point
      </span>
    </div>
    
    <div className="ml-6 flex flex-col">
      {order?.project_location?.area && (
        <span className="text-[16px] font-bold text-gray-900 mb-1">
          {order.project_location.area}
        </span>
      )}
      {order?.distance_from_delivery_location_km && (
        <span className="text-[12px] text-gray-500">
          {order.distance_from_delivery_location_km} km from your store
        </span>
      )}
    </div>
  </div>
)}


  <div className="border-t border-gray-200 my-3"></div>

  {/* Delivery Included Row */}
  <div className="flex items-center justify-between">
    <div className="flex items-center space-x-2">
      <div className="flex items-center justify-center w-8 h-8">
        <FontAwesomeIcon icon={faTruck} className="text-gray-600 " />
      </div>
      <span className="text-xs text-[#000000]">Do you want to include DELIVERY?</span>
    </div>

    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={deliveryIncluded === "Yes"}
        onChange={() =>
          isEditable &&
          setDeliveryIncluded(deliveryIncluded === "Yes" ? "No" : "Yes")
        }
        disabled={!isEditable}
      />

      <div
        className="
          w-11 h-6
          bg-gray-200
          rounded-full
          peer-checked:bg-red-500
          transition-colors duration-300
          shadow-inner
        "
      ></div>

      <div
        className="
          absolute left-0.5 top-0.5
          w-5 h-5
          bg-white
          rounded-full
          shadow
          transition-transform duration-300
          peer-checked:translate-x-5
        "
      ></div>
    </label>
  </div>

  {/* Estimated Delivery Time - only when deliveryIncluded === "Yes" */}
  {deliveryIncluded === "Yes" && (
    <div className="mt-4">
      <p className="text-sm font-semibold text-gray-500 mb-2">Set an estimated delivery time</p>

      <div className="bg-gray-100 rounded-lg p-2 flex items-center justify-around space-x-2">
        {["1", "3", "6", "12", "24"].map((time) => (
          <button
            key={time}
            onClick={() => handleDeliveryTimeChange(time)}
            className={`px-3 py-1 text-xs font-medium rounded-md transition ${
              deliveryTime === parseInt(time) ? "bg-red-500 text-white" : "bg-white text-[#000000]"
            }`}
          >
            {time} {time === "1" ? "hr" : "hrs"}
          </button>
        ))}
      </div>
    </div>
  )}
</div>





{/* Delivery distance info and delivery time ends */}

{!isProposingAmendments && (
<div className='rounded-lg mt-2 bg-white p-4 border border-gray-200 shadow-sm'>
  <h2 className='text-lg font-medium text-gray-800 mb-2 pb-2 '>Bill Details</h2>
  
  <div className='space-y-3'>
  <div className='flex justify-between items-center'>
    <div className='flex flex-row items-center'>
      <div className='w-6 h-6 mr-2 flex items-center justify-center'>
        {/* Optional image with consistent spacing */}
        {ListView && (
          <img 
            src={ListView} 
            alt="img" 
            className='max-w-full max-h-full object-contain'
          />
        )}
      </div>
      <span className='text-black'>Items Total</span>
    </div>
    <span className='font-medium text-black'>₹{order?.subtotal?.toLocaleString()}</span>
  </div>
  
  <div className='flex justify-between items-center'>
    <div className='flex flex-row items-center'>
      <div className='w-6 h-6 mr-2 flex items-center justify-center'>
        {/* Optional image with consistent spacing */}
        {GST && (
          <img 
            src={GST} 
            alt="img" 
            className='max-w-full max-h-full object-contain'
          />
        )}
      </div>
      <span className='text-black'>GST (18%)</span>
    </div>
    <span className='font-medium text-black'>₹{order?.tax_amount?.toLocaleString()}</span>
  </div>
  
  <div className='border-t border-[#D7D4D4] my-2'></div>
  
  <div className='flex justify-between items-center rounded'>
    <span className='font-bold text-[#524D4D]'>Grand Total</span>
    <span className='font-semibold text-black'>
      ₹{(order?.subtotal + order?.tax_amount)?.toLocaleString()}
    </span>
  </div>
</div>

</div>
)}



<div className="flex items-center justify-between rounded-lg mt-2  bg-white p-4 shadow-sm border border-gray-200">
  <p className="text-xs font-semibold text-gray-700">
    Need Help? Contact our Support Team
  </p>
  <div className="flex space-x-3">
   <a href="tel:8247895454">
  <button className="flex items-center justify-center bg-blue-100 rounded-full p-2 hover:bg-blue-200 transition">
    <img src={Phone} alt="Phone" className="w-5 h-5 object-cover" />
  </button>
</a>
    <a href="https://wa.me/918247895454" target="_blank" rel="noopener noreferrer">
  <button className="flex items-center justify-center bg-green-100 rounded-full p-2 hover:bg-green-200 transition">
    <img src={Whatsapp} alt="WhatsApp" className="w-5 h-5" />
  </button>
</a>
     {/* <button className="flex items-center justify-center bg-red-100 rounded-full p-2 hover:bg-red-200 transition">
      <img src={Chat} alt="Chat" className="w-5 h-5 " />
    </button>  */}
  </div>
</div>

{/* Skip order option when the new order has been received */}
{/*   {order && order?.vendor_status === 'Respond Now' && (
  !isExpired ? (
<div className="flex items-center justify-center mt-4 ">
  <button onClick={handleSkipOrder}
  className="rounded-lg font-semibold px-10 py-2 border border-[#F84C5C] text-sm font-semibold text-[#F84C5C]">
    Skip Order
  </button>
</div>
  ): null 
  )} */}

{/*  if status is accepted / counter offer then show this button */}
{/* {order && (order.vendor_status === 'Accepted' || order.vendor_status === 'Counter Offer') && (
  <div className="flex items-center justify-center mt-4 ">
    <button
      onClick={() => setIsWithdrawModalOpen(true)}
      className="rounded-lg font-semibold px-8 py-2 border border-[#F84C5C] text-sm text-[#F84C5C] hover:bg-[#F84C5C] hover:text-white transition"
    >
      {order.vendor_status === 'Accepted'
        ? 'Withdraw Acceptance'
        : 'Withdraw Counter Offer'}
    </button>
  </div>
)} */}


{/* Modify the button section */}
  
{order?.vendor_status === 'Respond Now' && !isExpired && !isCounterOfferMode && (
<div className="fixed bottom-0 left-0 right-0 z-50 bg-white p-4 shadow-lg border-t border-gray-200">
    <div className="flex flex-row gap-3">
      <button
        onClick={handleAcceptOrder}
        className="flex-1 bg-[#F43042] hover:bg-[#D64541] hover:text-white text-white font-medium py-3 px-4 rounded-md transition duration-300 flex items-center justify-center"
      >
        Accept Order
      </button>
      <button
        onClick={handleProposeAmendments}
        className="flex-1 border border-[#D64541] hover:bg-[#D64541] hover:text-white text-[#D64541] font-medium py-3 px-4 rounded-md transition duration-300 flex items-center justify-center"
      >
        Counter Offer
      </button>
    </div>
  </div>
 )} 



{isCounterOfferMode && (
  <div className="fixed bottom-0 left-0 right-0 z-40 bg-white p-4 shadow-lg ">
    <div className='flex flex-row justify-between'>
    
      <button
        onClick={() => HandleWindowLoad()}
        className='mr-2 flex-1 border border-[#D64541] text-[#D64541] font-medium py-3 px-4 rounded-md transition duration-300'
      >
        Cancel 
      </button>
        <button
        onClick={SaveProposedAmmendments}
        className='flex-1 bg-[#D64541] text-white font-medium py-3 px-4 rounded-md transition duration-300'
      >
        Submit Counter
      </button>
    </div>
  </div>
)}

{/* {PriceValidityModalOpen && (
  <div 
    className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50"
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setPriceValidityModalOpen(false);
        setIsCounterOffer(false);
      }
    }}
  >
    <div 
      className="bg-white w-full rounded-t-2xl max-w-md animate-slide-up"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="p-4 border-b border-[#E0D9D9] flex justify-between items-center">
        <button 
          onClick={() => {
            setPriceValidityModalOpen(false);
            setIsCounterOffer(false);
          }}
          className="text-gray-700 hover:text-gray-900"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <h2 className="text-xl font-medium absolute left-1/2 transform -translate-x-1/2">
          {isCounterOffer ? 'Counter Offer ' : 'Accept Offer'}
        </h2>
      </div>

      <div className='p-4'>
        <h1 className='font-medium rounded-lg px-4 py-1 text-[#1A73E7] text-sm text-left border border-[#E0D9D9]'>
Missing confirmed items at pickup may pause new orders and incur a penalty. Timely fulfilment helps maintain trust and order flow.
        </h1>
      </div>

      <p className="px-3 text-sm text-black text-left mb-4">
        {isCounterOffer 
          ? 'Choose how your counter offer should be considered:' 
          : 'Please choose how your prices should be considered for this order:'}
      </p>

      <div className="px-6 space-y-4 mb-6">
        <div className="rounded-lg px-3 py-4 border border-[#E0D9D9] flex items-center">
          <input
            type="radio"
            id="Full"
            name="priceValidity"
            className="mr-3 appearance-none h-4 w-4 rounded-full border border-[#DE1B52] checked:bg-[#DE1B52] checked:border-[#DE1B52] focus:ring-[#DE1B52] focus:ring-offset-0"
            checked={priceValidityOption === 'Full'}
            onChange={() => setPriceValidityOption('Full')}
          />
          <label htmlFor="Full" className="text-black font-medium flex-1">
            {isCounterOffer 
              ? 'Counter offer valid only on full order' 
              : 'Prices valid only on full order'}
          </label>
        </div>

        <div className="rounded-lg px-3 py-2 border border-[#E0D9D9] flex items-center">
          <input
            type="radio"
            id="Partial"
            name="priceValidity"
            className="mr-3 appearance-none h-4 w-4 rounded-full border border-[#DE1B52] checked:bg-[#DE1B52] checked:border-[#DE1B52] focus:ring-[#DE1B52] focus:ring-offset-0"
            checked={priceValidityOption === 'Partial'}
            onChange={() => setPriceValidityOption('Partial')}
          />
          <label htmlFor="Partial" className="text-black font-medium flex-1">
            {isCounterOffer 
              ? 'Counter offer valid on partial order (1 or more products)' 
              : 'Prices valid on partial order (1 or more products)'}
          </label>
        </div>
      </div>

      <div className='p-3 flex flex-row gap-3'>
        <button
          onClick={() => {
            setPriceValidityModalOpen(false);
            setIsCounterOffer(false);
          }}
          className='flex-1 border border-[#D64541] text-[#D64541] font-medium py-3 px-4 rounded-md transition duration-300'
        >
          Cancel
        </button>
        <button
          onClick={handleConfirmResponse}
          disabled={!priceValidityOption}
          className={`flex-1 font-medium py-3 px-4 rounded-md transition duration-300 ${
            priceValidityOption 
              ? 'bg-[#D64541] text-white' 
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          Submit
        </button>
      </div>
    </div>
  </div>
)} */}

    </div>
       </>
      )}

{isCounterOfferModalOpen && (
  <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50">
    <div className="bg-white w-full rounded-t-2xl h-[90vh] flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-[#E0D9D9] flex justify-between items-center">
        <button
          onClick={() => setIsCounterOfferModalOpen(false)}
          className="text-gray-700 hover:text-gray-900"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <h2 className="text-xl font-medium absolute left-1/2 transform -translate-x-1/2">
          Counter Offer
        </h2>
      </div>

      {/* Description */}
      <div className='p-4 py-2 text-sm border-b border-[#E0D9D9]'>
        <p>Enter your counter price and quantities available with you.</p>
      </div>

      {/* Scrollable Content */}
      <div className='flex-grow overflow-y-auto px-4 pt-4 pb-5'>
        {amendedItems
        .filter(item => !item.not_available)
        .map((item, index) => (
          <div 
            key={item.item_id|| index} 
            className="mb-4 border border-[#E0D9D9] px-2 py-4 rounded-lg"
          >
            <div className="flex items-center">
              <img
                src={
                  item.item_image
                    ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.item_image}`.trim()
                    : Default
                }
                alt={item.item_name}
                className="w-16 h-16 object-cover rounded-lg mr-4"
              />
              
              <div className="flex-1">
                <h3 className="font-medium text-sm">{item.item_name}</h3>
                <div className='flex justify-between items-start flex-row space-x-4'>
                  <div className="text-left flex flex-col justify-start items-start mt-2 w-full">
                    <span className="text-[#524D4D] text-left mr-2 mb-1">Quantity</span>
                    <div className="border border-[#F84C5C] text-[#F84C5C] font-bold rounded-lg  flex items-center">
                     {/*  <button
                        onClick={() => updateCounterOfferQuantity(index, -1)}
                        className="rounded-lg text-lg px-2 py-1"
                      >
                        -
                      </button> */}
                      <span className="px-4">{item.proposed_quantity}</span>
                     {/*  <button
                        onClick={() => updateCounterOfferQuantity(index, 1)}
                        className="rounded-lg text-lg px-2 py-1"
                      >
                        +
                      </button> */}
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-start mt-2">
                    <span className="text-[#524D4D] mr-2 mb-1">Price/{item.UOM}</span>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span className="text-gray-500">₹</span>
                      </div>
                      <input
                        type='number'
                        value={item.proposed_selling_price}
                        onChange={(e) => updateItemPrice(item.item_id, parseFloat(e.target.value))}
                        className='w-24 border border-[#E0D9D9] rounded px-2 py-1 pl-6'
                        min='0'
                        step='0.01'
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Floating Action Buttons */}
      <div className='sticky bottom-0 bg-white p-4 flex flex-row justify-between gap-3 shadow-top'>
        <button
          onClick={() => setIsCounterOfferModalOpen(false)}
          className='font-semibold w-full px-6 py-2 border border-[#F84C5C] rounded-lg text-[#F84C5C] hover:bg-gray-50 transition-colors duration-200'
        >
          Cancel
        </button>
        <button
          onClick={() => handleSaveAmendments()}
          className="font-semibold w-full px-6 py-2 bg-[#D64541] text-white rounded-lg hover:bg-[#C03A36] transition-colors duration-200"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}


{isWithdrawModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl transform transition-all duration-300 ease-in-out">
      <h2 className="text-xl font-semibold mb-4 text-center text-[#524D4D]">
        Are you sure you want to withdraw Acceptance?
      </h2>
      <p className="text-gray-600 text-center mb-6 text-sm">
        Once withdrawn, you cannot accept the order again. You can either skip or submit a counter offer.
      </p>
      <div className="space-y-4 flex flex-col items-center">
        <button
          onClick={handleWithdrawAcceptance}
          className="text-md px-10 py-2 bg-[#F43042] text-white rounded-full hover:bg-[#D64541] transition-colors duration-300 shadow-md"
        >
          Yes
        </button>
        <button
          onClick={() => setIsWithdrawModalOpen(false)}
          className="font-bold text-md text-[#C20C0C] hover:underline transition-colors duration-300"
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

{skipOrderReasonsModal && (
  <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50">
    <div className="bg-white w-full rounded-t-2xl ">
      {/* Header */}
      <div className="p-4 border-b border-[#E0D9D9] flex justify-between items-center">
        <button
          onClick={() => setSkipOrderReasonsModal(false)}
          className="text-gray-700 hover:text-gray-900"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <h2 className="text-xl font-medium absolute left-1/2 transform -translate-x-1/2">
          Skip Order?
        </h2>
      </div>

      {/* Content */}
      <div className="max-h-[60vh] overflow-y-auto p-4 space-y-4">
        <div>
          <h1 className="text-lg font-semibold text-[#524D4D] mb-2">
            Why do you want to skip the order?
          </h1>
          <p className="text-sm text-gray-500 mb-4">Optional</p>
        </div>

        {/* Reason Options */}
        <div className="space-y-4">
          {[
            "Cannot fulfill the whole order (Only partial order fulfillment possible)",
            "Cannot supply at that price",
            "Stock is not available",
            "Stopped selling few of the products in the order",
            "Other..."
          ].map((reason, index) => (
            <div 
              key={index}
              className={`border border-[#E0D9D9] rounded-lg p-4 cursor-pointer hover:bg-gray-50 transition-colors duration-300 ${
                selectedSkipReason === reason 
                  ? 'border-[#D64541] bg-[#FFF5F4]' 
                  : ''
              }`}
              onClick={() => setSelectedSkipReason(reason)}
            >
              <div className="flex items-center justify-between">
                <span className="text-[#524D4D] font-medium">{reason}</span>
                {selectedSkipReason === reason && (
                  <FontAwesomeIcon 
                    icon={faCheck} 
                    className="text-[#D64541]" 
                  />
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSkipOrderSubmit}
          disabled={!selectedSkipReason}
          className={`w-full py-3 rounded-lg mt-4 transition-colors duration-300 ${
            selectedSkipReason
              ? 'bg-[#D64541] text-white hover:bg-opacity-90'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          Submit
        </button>
      </div>
    </div>
  </div>
)}


{/* Add this modal to your return statement */}
{showNavigationWarningModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl">
      <div className="text-center">
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-[#524D4D] mb-2">
            Respond to Order
          </h2>
         {/*  <p className="text-sm text-gray-600 mb-4">
            Kindly Respond Now to the order
          </p> */}
        </div>

        {/* Time Remaining Display */}
        <div className="flex justify-center items-center space-x-2 mb-4">
          <span className="text-sm font-medium text-[#524D4D]">Time Remaining:</span>
          <div className="flex items-center space-x-1">
            {/* Minutes Block */}
            <div className="border border-[#E0D9D9] px-3 py-1 rounded flex flex-col items-center">
              <span className="text-[#170101] font-bold text-sm">
                {timeRemaining?.minutes != null ? timeRemaining.minutes : '--'}
              </span>
              <span className="font-medium text-[#524D4D] text-xs">mins</span>
            </div>
            <div className="font-bold">:</div>
            {/* Seconds Block */}
            <div className="border border-[#E0D9D9] px-3 py-1 rounded flex flex-col items-center">
              <span className="text-[#170101] font-bold text-sm">
                {timeRemaining?.seconds != null
                  ? (timeRemaining.seconds < 10
                      ? `0${timeRemaining.seconds}`
                      : timeRemaining.seconds)
                  : '--'}
              </span>
              <span className="font-medium text-[#524D4D] text-xs">sec</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center space-x-4">
          <button
            onClick={() => setShowNavigationWarningModal(false)}
            className="px-4 py-2 border border-[#D64541] text-[#D64541] rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              // Optional: You can add any additional logic here if needed
              setShowNavigationWarningModal(false);
            }}
            className="px-4 py-2 bg-[#D64541] text-white rounded-md hover:bg-[#C03A36]"
          >
            Respond to Order
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{itemsReadyPopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl">
      <div className="text-center">
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-[#524D4D] mb-2">
           Are you sure that order items are ready?
          </h2>
         {/*  <p className="text-sm text-gray-600 mb-4">
            Kindly Respond Now to the order
          </p> */}
        </div>

        {/* Time Remaining Display */}
        <div className="flex justify-center items-center space-x-2 mb-4">
          <span className="text-sm font-medium text-[#524D4D]">You will be rated low on the next orders, if Items are not ready at the time of delivery partner pickup</span>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center space-x-4">
          <button
            onClick={() => setItemsReadyPopup(false)}
            className="px-4 py-2 border border-[#D64541] text-[#D64541] rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleItemsReady}
            className="px-4 py-2 bg-[#D64541] text-white rounded-md hover:bg-[#C03A36]"
          >
            Items Ready
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{/* Verify Otp popup */}
{isOTPModalOpen && (
  <div 
    className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50"
    onClick={(e) => {
      // Close modal when clicking on background (outside popup)
      if (e.target === e.currentTarget) {
        closeOTPModal();
      }
    }}
  >
    {/* Modal content */}
    <div 
      className="bg-white w-full rounded-t-2xl max-w-md animate-slide-up relative"
      onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside popup
    >
      {/* Header with close button */}
      <div className="p-6 border-b border-gray-200 relative">
        {/* Close button at top-right corner */}
        <button
          onClick={closeOTPModal}
          className="absolute top-4 right-4 bg-gray-100 hover:bg-gray-200 rounded-full p-2 transition-colors"
        >
          <FontAwesomeIcon icon={faTimes} className="text-gray-600 text-sm" />
        </button>
        
        <h2 className="text-xl font-semibold text-center text-[#524D4D] pr-8">
          Verify OTP
        </h2>
        <p className="font-medium text-xs text-[#524D4D] text-center mt-2">
          Enter the 4-digit OTP provided by the delivery partner
        </p>
      </div>

      {/* OTP Input Fields */}
      <div className="p-6">
        <div className="flex justify-center space-x-4 mb-6">
          {otpValues.map((value, index) => (
            <input
              key={index}
              ref={otpRefs[index]}
              type="text"
              maxLength="1"
              value={value}
              onChange={(e) => handleOTPChange(index, e.target.value)}
              onKeyDown={(e) => handleOTPKeyDown(index, e)}
              className="w-12 h-12 text-center text-xl font-bold border-2 border-gray-300 rounded-lg focus:border-[#F43042] focus:outline-none transition-colors"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          ))}
        </div>

        {/* Verify Button */}
        <button
          onClick={handleVerifyOTP}
          disabled={isVerifyingOTP || otpValues.join('').length !== 4}
          className={`w-full py-3 rounded-lg font-semibold transition-colors ${
            isVerifyingOTP || otpValues.join('').length !== 4
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-[#F43042] text-white hover:bg-[#D64541]'
          }`}
        >
          {isVerifyingOTP ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
              Verifying...
            </div>
          ) : (
            'Verify OTP'
          )}
        </button>
      </div>
    </div>
  </div>
)}


{showConfirmationModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl">
      <h2 className="text-md font-semibold mb-4 text-center text-[#524D4D]">
        Are you sure you want to confirm your RFQ order?
      </h2>
      <div className="flex justify-center space-x-8">
        <button
          onClick={() => setShowConfirmationModal(false)}
          className="px-4 py-1 border border-[#D64541] text-[#D64541] rounded-md hover:bg-gray-50"
        >
          No
        </button>
        <button
          onClick={() => {
            setShowConfirmationModal(false);
            setPriceValidityOption('Full'); // Set default to 'Full' since modal is removed
            handleConfirmResponse(); // Directly submit to backend
          }}
          className="px-4 py-1 bg-[#D64541] text-white rounded-md hover:bg-[#C03A36]"
        >
        Yes
        </button>
      </div>
    </div>
  </div>
)}

<DeliveryValidationModal 
        visible={showValidationModal}
        onClose={() => setShowValidationModal(false)}
      />

     <ItemNotAvailableBottomSheet 
        item={selectedItem}
        isOpen={isBottomSheetOpen}
        onClose={() => setIsBottomSheetOpen(false)}
        onSuggestAlternative={handleSuggestAlternative}
        onMarkNotAvailable={handleMarkNotAvailable}
      />

      <SuggestAlternativeBottomSheet 
        item={selectedItem}
        isOpen={isSuggestAlternativeOpen}
        onClose={() => setIsSuggestAlternativeOpen(false)}
        onBack={handleBackFromSuggest}
        preloadedItems={suggestedItems}
        order={order} 
        setOrder={setOrder}
      />

{/* Pass orders length from Snackbar */}
<div className='fixed bottom-0 left-0 right-0 z-10'>
    <Snackbar 
        ref={snackbarRef}
        snackbarState={snackbarState}
        notifications={notifications}
        minimizeSnackbar={minimizeSnackbar}
        expandSnackbar={expandSnackbar}
        hideSnackbar={hideSnackbar}
        customStyle={{
            bottom: (
                order?.vendor_status?.toLowerCase() === 'respond now'
                    ? (!isExpired ? '85px' : '20px')
                    : '10px'
            ),
            marginBottom: '10px'  // Additional margin if needed
        }}
    /> 
</div>


    </div>
  )
};
  export default RFQDetails;